import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { NoteDTO } from "../../../api/api";
import type { PackageResponse } from "./packagesApi";
import { updatePackageNotes } from "./packagesApi";

export const useUpdatePackageNotes = (packageId: string) => {
  const queryClient = useQueryClient();

  const updatePackageNotesMutation = useMutation<PackageResponse, unknown, { notes: NoteDTO[] }>({
    mutationFn: ({ notes }) => updatePackageNotes(packageId, notes),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["packages"] });
      await queryClient.invalidateQueries({ queryKey: ["packages", packageId] });
    },
  });

  return {
    updatePackageNotes: (notes: NoteDTO[]) => updatePackageNotesMutation.mutateAsync({ notes }),
  };
};
